
import { CardRound } from "./CardRound";
import { useEffect, useState } from "react";
import { formatDate } from "../utils/helper";

const ScheduleComponent = ({datas}) => {
    const [matches, setMatches] = useState([])
    useEffect(() => {
        const round  = [];
        const matchesTemp = Object.entries(datas).map(
            ([id, match] ) => ({ id, ...match })
          );
        matchesTemp.forEach((match) => {
        if (!round.includes(match.tournamentRoundText)) {
            round.push(match.tournamentRoundText);
        }
        });
        console.log(matchesTemp)
        setMatches(
        round
            .map((round) => ({
            round,
            matches: matchesTemp
                .filter((match) => round === match.tournamentRoundText)
                .map((match) => ({
                ...match,
                startTime: match.startTime + ' WIB',
                participants: Object.entries(match.participants).map(
                    ([_, data] ) => ({ ...data })
                ),
                })),
            }))
            .reverse()
        );
    }, [datas])

        return (
        <div className="md:flex flex-col md:justify-center overflow-auto text-[#2BBACA]">
            {matches.length > 0 && 
                matches.map(match => {
                    return (
                        <CardRound 
                            matches={match.matches} 
                            nameRound={match.round} 
                            key={match.round}/>
                    )
                })
            }
        </div>
        )
    }

export default ScheduleComponent;
  